import { Link } from 'react-router-dom';

/**
 * Zehuma QR Menü — metin + basit marka (SVG), ek görsel dosyası gerekmez
 */
export default function ZehumaLogo({ className = '', to = '/' }) {
    return (
        <Link to={to} className={`flex items-center gap-2.5 group ${className}`} aria-label="Zehuma QR Menü — Ana sayfa">
            <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-violet-600 via-fuchsia-600 to-amber-500 shadow-md ring-2 ring-white/30 group-hover:ring-amber-200/60 transition">
                <svg viewBox="0 0 40 40" className="h-6 w-6 text-white" fill="none" aria-hidden="true">
                    <path
                        d="M12 8h6l10 24h-6L12 8zm10 0h6l-3 8h-6l3-8z"
                        fill="currentColor"
                        opacity="0.95"
                    />
                </svg>
            </span>
            <span className="flex flex-col leading-tight">
                <span className="text-lg font-bold tracking-tight text-slate-900 group-hover:text-violet-700 transition">
                    Zehuma
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-violet-600/90">
                    QR Menü
                </span>
            </span>
        </Link>
    );
}
